'use client';
import { objectKeys } from '@s7/utils';

function filterProps(props, filter) {
    return objectKeys(props).reduce(function(target, key) {
        if (props[key] !== undefined) {
            if (filter && filter.includes(key)) {
                return target;
            }
            target[key] = props[key];
        }
        return target;
    }, {});
}

export { filterProps };
